export default "__VITE_ASSET__BlXNtM2b__"